module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-4-635ed488.png";